import React, {useCallback, useState} from 'react';
import {Button, Col, Row} from 'reactstrap';

import Modal from 'components/Modal';
import useExitIntent from 'utils/useExitIntent.js';

export default function ModalExitLanding(props) {
  const {isOpen, toggle} = useExitIntent(30000);
  return (
    <Modal className="modal-exit-intent modal-exit-intent-landing" isOpen={isOpen} toggle={toggle}>
      <Row className="text-center text-lg-left d-flex align-items-stretch m-0">
        <Col xs="12" lg="7" className="modal-exit-intent-copy order-lg-2 my-auto">
          <h4 className="section-heading mb-4">Are you eating the wrong foods that zap your health?</h4>
          <p className="mb-0">
            Learn what to eat to slash your risk of cancer, heart disease, Type 2 diabetes, autoimmune conditions, and
            Alzheimer’s, as well as obesity.
          </p>
          <Button className="btn-exit text-uppercase text-white text-h5" color="cta" onClick={toggle} block>
            Watch the <br />
            Mini-Masterclass
          </Button>
        </Col>
        <Col xs="12" lg="5" className="exit-modal-image-col order-lg-1">
          <div
            className="exit-modal-image"
            style={{backgroundImage: `url('${require('static/backgrounds/1333708460-exit.jpg')}')`}}
          />
        </Col>
      </Row>
    </Modal>
  );
}
